import {useCallback} from 'react';
import AnalyticsService, {
  eventNames,
} from '@/services/analytics/AnalyticsService';

type PurchaseProcessStartedEventParams = {
  flow_id?: string;
  presentation_id: string;
  process_id: string;
  product_id: string;
  promotional_offer_id?: string;
  product_name: string;
};

function usePurchaseProcessStartedEvent(flowName?: string) {
  const purchaseProcessStarted = useCallback(
    ({
      flow_id = '',
      presentation_id,
      process_id,
      product_id,
      promotional_offer_id = '',
      product_name,
    }: PurchaseProcessStartedEventParams) => {
      const flow = flowName ? AnalyticsService.getFlow(flowName) : undefined;
      AnalyticsService.dispatchEvent(
        eventNames.CONTENT_STUDIO_STORE_PURCHASE_PROCESS_STARTED,
        {
          flow_id: flow?.flow_id || flow_id,
          presentation_id,
          process_id,
          product_id,
          promotional_offer_id,
          product_name,
        }
      );
    },
    []
  );

  return {purchaseProcessStarted};
}

export default usePurchaseProcessStartedEvent;
